import React from "react";
import { Helmet } from "react-helmet";
import "./Legal.css";

export const RefundPolicy = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/refunds`;
  const description = "FlintHost refund and withdrawal policy for EU customers.";
  return (
    <div className="legal-page">
      <Helmet>
        <title>FlintHost | Refund Policy</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Refund Policy" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Refund Policy" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <div className="legal-hero">
        <p className="legal-eyebrow">Legal</p>
        <h1>Refund Policy</h1>
        <p>Effective date: 1 January 2026</p>
      </div>
      <div className="legal-nav">
        <a href="/tos">Terms of Service</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/acceptable-use">Acceptable Use</a>
        <a href="/refunds" aria-current="page">Refund Policy</a>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Standard refunds</h2>
          <p>
            If you are not satisfied, you may request a refund within 72 hours of your first purchase for that service.
            Refunds are not provided for additional renewals, add-ons, or third-party licenses.
          </p>
        </section>
        <section className="legal-section">
          <h2>2. EU right of withdrawal</h2>
          <p>
            If you are an EU/EEA consumer, you have a 14-day right of withdrawal for digital services unless the
            service has started with your explicit consent and acknowledgement that you lose the withdrawal right.
            By ordering hosting that begins immediately, you request immediate performance and acknowledge this waiver.
          </p>
        </section>
        <section className="legal-section">
          <h2>3. Non-refundable cases</h2>
          <ul>
            <li>Services terminated for Acceptable Use violations.</li>
            <li>Chargebacks or fraudulent transactions.</li>
            <li>Dedicated or custom services provisioned specifically for you.</li>
          </ul>
        </section>
        <section className="legal-section">
          <h2>4. How to request</h2>
          <p>
            Contact <a href="mailto:contact@flinthost.com">contact@flinthost.com</a> with your account email,
            invoice number, and reason for the request. Approved refunds are issued to the original payment method.
          </p>
        </section>
      </div>
    </div>
  );
};
